import { FC } from "react";
import { CopyLinkButton } from "./CopyLinkButton";
import { Button } from "./ui/button";
import { MessageCircle } from "lucide-react";

interface LinkCardProps {
  title: string;
  url: string;
  displayUrl?: string;
  whatsapp_number: string;
  message_template: string;
  description?: string;
}

export const LinkCard: FC<LinkCardProps> = ({
  title,
  url,
  displayUrl,
  whatsapp_number,
  message_template,
  description,
}) => {
  const handleWhatsAppClick = () => {
    const formattedMessage = message_template.replace("{product}", title);
    const whatsappUrl = `https://wa.me/${whatsapp_number}?text=${encodeURIComponent(
      formattedMessage
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  const displayLink = displayUrl || `jual.in/${title}`;
  const actualUrl = `https://jual.in/${title}`;

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border p-3 space-y-2">
      <div className="flex justify-between items-start gap-2">
        <div>
          <h3 className="font-semibold text-base">{title}</h3>
          {description && description.trim() !== "" && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {description}
            </p>
          )}
          <a
            href={actualUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-green-600 hover:text-green-700 dark:text-green-400 dark:hover:text-green-300"
          >
            {displayLink}
          </a>
        </div>
        <div className="flex gap-2">
          <CopyLinkButton link={actualUrl} />
          <Button
            variant="outline"
            size="sm"
            className="text-green-600 border-green-600 hover:bg-green-50 dark:text-green-400 dark:border-green-400 dark:hover:bg-green-950"
            onClick={handleWhatsAppClick}
          >
            <MessageCircle className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
};